import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import SearchInput from "../../components/SearchInput"; 
import { authFetch } from "../../utils/api"; 
import "../../styles/admin/aseguradoras.css"; 

export default function Puertos() {
  const [q, setQ] = useState("");
  const [puertos, setPuertos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError(null);
    authFetch('/api/Puerto')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Error al cargar puertos');
        }
        return res.json();
      })
      .then((data) => {
        setPuertos(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setPuertos([]);
        setLoading(false);
      });
  }, []);

  const rows = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return puertos;

    return puertos.filter(r =>
      [r.nombre, r.contacto, r.telefono, r.correoElectronico].some(v =>
        String(v).toLowerCase().includes(t)
      )
    );
  }, [q, puertos]);

  const handleAgregar = () => {
    navigate('/admin/puertos/agregar');
  };

  const handleEditar = (puerto) => {
    navigate(`/admin/puertos/editar/${puerto.id}`);
  };

  const handleDelete = async (puerto) => {
    const confirmacion = window.confirm(
      `¿Estás seguro de que deseas eliminar el puerto "${puerto.nombre}"?`
    );

    if (!confirmacion) {
      return;
    }

    try {
      const response = await authFetch(`/api/Puerto/${puerto.id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('No se pudo eliminar el puerto.');
      }

      setPuertos(prevPuertos =>
        prevPuertos.filter(p => p.id !== puerto.id)
      );

      alert('Puerto eliminado exitosamente.');

    } catch (err) {
      alert(`Error: ${err.message}`);
    }
  };

  return (
    <main className="aseg-main">
      <header className="aseg-header">
        <h1 className="aseg-title">Puertos</h1>
        <button className="aseg-btn" onClick={handleAgregar}>
          Agregar Puerto
        </button>
      </header>
    
      <SearchInput
        placeholder="Buscar puertos"
        value={q}
        onChange={setQ} 
      />

      {loading && <p>Cargando puertos...</p>}

      {error && <p style={{ color: '#e11d48' }}>Error: {error}</p>}

      {!loading && !error && (
        <div className="aseg-card">
          <div className="aseg-table-wrapper">
            <table className="aseg-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Correo electrónico</th>
                  <th className="col-acciones">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map(r => (
                    <tr key={r.id}>
                      <td>{r.nombre}</td>
                      <td>{r.telefono}</td>
                      <td className="td-email">{r.correoElectronico}</td>
                      <td className="td-acciones">
                        <button
                          type="button"
                          className="aseg-link"
                          onClick={() => handleEditar(r)}
                        >
                          Editar
                        </button>
                        <button
                          type="button"
                          className="aseg-link"
                          style={{ marginLeft: '8px' }}
                          onClick={() => handleDelete(r)}
                        >
                          Borrar
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="aseg-empty">
                      No se encontraron puertos{q ? ' que coincidan con la búsqueda' : ''}.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </main>
  );
}